var m = require('mithril');
var prop = require('mithril/stream')
var flash = require('../../components/flash');
var modal = require('../../layout/components/modal');
var key = require('../../libs/keybindings');
var loaders = require('../../layout/components/loaders');
var buttonElement = require('../../components/button');
var enumerationTemplateModal = require('./enumerationTemplateModal');
var hasEnumerationOptions = require('./hasEnumerationOptions');

var enumerationModal = {};
enumerationModal.errors = [];
var incompleteEnumerationOptionError = 'Enumeration options need both Show and As values';

modal.once('closed', function() {
  key.deleteScope('modal');
  key.setScope('home');
});


enumerationModal.editDialogue = function(pointRecord, options) {
  enumerationModal.errors = [];
  enumerationModal.enumerations = prop([]);
  enumerationModal.pointRecord = pointRecord;
  enumerationModal.options = options;
  enumerationModal.enumerationRecordTemplateRid = prop();
  enumerationModal.enumerationRecordTemplate = prop();
  enumerationModal.form = {};
  enumerationModal.form.enumeration = prop ([]);
  enumerationModal.form.json = prop('');
  enumerationModal.view = prop('editor');

  if (hasEnumerationOptions(pointRecord().enumeration)) {
    enumerationModal.form.enumeration(Object.keys(pointRecord().enumeration).map(key => ({name: pointRecord().enumeration[key], id: key})));
  }

  loaders.requestWithLoader({
    url: '/api/v1/enumeration/',
    method: 'GET',
    background: true
  })
  .then(function(data) {
    enumerationModal.enumerations(data);
    m.redraw();
  });



  var submit = function() {
    let body = {
      enumeration: {}
    }
    if (enumerationModal.view() == 'editor') {
      enumerationModal.form.enumeration().forEach(option => {
        const { name, id } = option;
        body.enumeration[id] = name;
      })

      if (hasEnumerationOptions.hasIncompleteOptions(body.enumeration)) {
        enumerationModal.errors = [incompleteEnumerationOptionError];
        m.redraw();
        return;
      }
    } else {
      if (isValidJSON(enumerationModal.form.json())) {
        body.enumeration = JSON.parse(enumerationModal.form.json());
      } else {
        enumerationModal.errors = ['Invalid JSON'];
        m.redraw();
        return;
      }

      if (hasEnumerationOptions.hasIncompleteOptions(body.enumeration)) {
        enumerationModal.errors = [incompleteEnumerationOptionError];
        m.redraw();
        return;
      }
    }

    if (!hasEnumerationOptions(body.enumeration)) {
      enumerationModal.errors = ['Add at least one enumeration option'];
      m.redraw();
      return;
    }

    return loaders.requestWithLoader({
      method: 'PUT',
      url: `/api/v1/point/${enumerationModal.pointRecord()['@rid'].slice(1)}`,
      body
    }).then(response=>{
      key.unbind('enter');
      options && options.submitCallback ? options.submitCallback() : '';
      modal.vm.close();
    })
  };

  key.setScope('modal');
  key('enter', 'modal', submit);

  modal.vm.title("Enumeration Editor");
  modal.vm.body = view;
  modal.vm.buttons([
    {
      label: "Switch Editor Mode",
      class: "dib mr2",
      func: () => { 
        enumerationModal.view() == 'editor' ? enumerationModal.view('json') : enumerationModal.view('editor')
        m.redraw();
      }
    },
    {
      label: "Save",
      class: "dib",
      func: submit
    }
  ])

  modal.vm.open()
};



function view() {
  if(enumerationModal.view() == 'editor') {
    let json = {};
    enumerationModal.form.enumeration().forEach(option => {
      const { name, id } = option;
      json[id] = name;
    })
    enumerationModal.form.json(JSON.stringify(json));
    return m('div',[
      m(flash, {items:enumerationModal.errors, bg: 'bg-red'}),
      m('label', 'Use Template:'),
      m('div.flex', [
        m("select.form-control", {
          value: enumerationModal.enumerationRecordTemplateRid(),  
          onchange: function (ev) { 
            enumerationModal.enumerationRecordTemplateRid(ev.target.value);
            if (enumerationModal.enumerationRecordTemplateRid()) {
              if (enumerationModal.enumerationRecordTemplateRid() == "New Template") {
                if (hasEnumerationOptions(enumerationModal.pointRecord().enumeration)) {
                  enumerationModal.form.enumeration(Object.keys(enumerationModal.pointRecord().enumeration).map(key => ({name: enumerationModal.pointRecord().enumeration[key], id: key})));
                } else {
                  enumerationModal.form.enumeration([]);
                }
              } else {
                enumerationModal.enumerationRecord = prop(enumerationModal.enumerations().filter(r=> r['@rid'] == enumerationModal.enumerationRecordTemplateRid())[0]);
                if (enumerationModal.enumerationRecord()) {
                  enumerationModal.form['@rid'] = prop(enumerationModal.enumerationRecord()['@rid']);
                  if (enumerationModal.enumerationRecord().options && Array.isArray(enumerationModal.enumerationRecord().options)) {
                    enumerationModal.form.enumeration = prop(enumerationModal.enumerationRecord().options.map((option, idx) => { return {name: Object.keys(option)[0], id: option[Object.keys(option)[0]]}}));
                  }
                }
              }
            }
          }
        }, [
          m("option", { value: null }, "New Template"), 
          enumerationModal.enumerations().map(function (enumeration) {
            return m("option", {
              value:enumeration['@rid']
            }, [
              enumeration.name
            ])
          }),    
        ]),
        enumerationModal.enumerationRecordTemplateRid() && enumerationModal.enumerationRecordTemplateRid() != "New Template" ?
            m(buttonElement, {
              class: 'ml2 w3',
              label: m('i.ion-ios-compose.blue'), 
              func: function () {
                enumerationTemplateModal.editDialogue(enumerationModal.enumerations().filter(r=> r['@rid'] == enumerationModal.enumerationRecordTemplateRid())[0], undefined, { submitCallback: enumerationModal.editDialogue.bind(enumerationModal, enumerationModal.pointRecord, enumerationModal.options)});
              }
            })
          :
          m(buttonElement, {
            class: 'ml2 w3',
            label: m('i.ion-plus.blue'), 
            func: function () {
              enumerationTemplateModal.editDialogue(undefined, enumerationModal.form.enumeration(), { submitCallback: enumerationModal.editDialogue.bind(enumerationModal, enumerationModal.pointRecord, enumerationModal.options)});
            }
          })
      ]),
      m('div', {class:'form-group'}, [
        m('div.f3.pv2', 'Options'),
        m('table.w-100.pt2.pb3', [
          m('thead', [
            m('tr', [
              m('th.tc.v-btm.fw2.bw1.ph2', [
                m('p.ma0.tc', 'Show')
              ]),
              m('th.tc.v-btm.fw2.bw1.ph2', [
                m('p.ma0.tc', 'As')
              ]),
            ])
          ]),
          m('tbody', {style:{background: '#111111'}}, [
            enumerationModal.form.enumeration().map((option, idx) => {
              return m('tr', [
                m('td.tc.bb-0.bl-0.bw1', [
                  m('input.form-control', {
                    id:'id-input', 
                    type:'text',
                    style: {background: 'inherit'},
                    oninput: function(ev){ option.id = ev.target.value; },
                    value: option.id,
                  })
                ]),
                m('td.tc.bb-0.bl-0.bw1', [
                  m('input.form-control', {
                    id:'name-input', 
                    type:'text', 
                    style: {background: 'inherit'},
                    oninput: function(ev){ option.name = ev.target.value; },
                    value: option.name,
                  })
                ]),
                m('td.br-0.bb-0.bl-0.bw1.w3', [
                  m(buttonElement, {
                    class: 'w3 fr',
                    label: m('i.f4.ion-ios-trash.red'), 
                    func: function() {
                      enumerationModal.form.enumeration().splice(idx, 1)
                    }
                  }),
                ])
              ])
            }),
            m('tr', {style: {background: '#111111'}}, [
              m('td'),
              m('td'),
              m('td', [
                m(buttonElement, {
                  class: 'w3 fr',
                  label: m('i.ion-plus.blue'), 
                  func: function() {
                    enumerationModal.form.enumeration().push({
                      name: '', 
                      id: ''
                    })
                  }
                })
              ])
            ])     
          ])
        ])
      ]),
    ])
  } else {
    return m('div',[
      m(flash, {items:enumerationModal.errors, bg: 'bg-red'}),
      m('label', 'Json:'),
      m('textarea', {
        rows:'5',
        cols:'40', 
        'box-sizing': 'border-box',
        placeholder:"Add Json template here...",
        oninput: updateJsonEditor,
        onchange: updateJsonEditor,
        value: enumerationModal.form.json()
      })
    ])
  }
}

function updateJsonEditor(ev) {
  var jsonValue = ev.target.value;
  enumerationModal.enumerationRecordTemplateRid("New Template");
  enumerationModal.form.json(jsonValue);
  enumerationModal.errors = [];

  if (isValidJSON(jsonValue)) {
    syncJsonEditorRows(jsonValue);
  }
}

function syncJsonEditorRows(jsonString) {
  let parsedJson = JSON.parse(jsonString);
  enumerationModal.form.enumeration(Object.keys(parsedJson).map(key => ({name: parsedJson[key], id: key})));
}

function isValidJSON(jsonString) {
  try {
      JSON.parse(jsonString);
      return true;
  } catch (e) {
      return false;
  }
}

module.exports = enumerationModal;
